import { createSelector } from 'reselect';

const selectLocations = (state: any) => state.locations;


export const selectLocationsCurrentItem = createSelector([selectLocations], (locations) => locations.current);

export const selectLocationsListItems = createSelector([selectLocations], (locations) => locations.list);

export const selectLocationsItemById = (itemId: any) =>
    createSelector(selectLocationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLocationsQueryItems = createSelector([selectLocations], (locations) => locations.query);

export const selectLocationsCreatedItem = createSelector([selectLocations], (locations) => locations.create);

export const selectLocationsUpdatedItem = createSelector([selectLocations], (locations) => locations.update);

export const selectLocationsReadItem = createSelector([selectLocations], (locations) => locations.read);

export const selectLocationsDeletedItem = createSelector([selectLocations], (locations) => locations.delete);

export const selectLocationsSearchedItems = createSelector([selectLocations], (locations) => locations.search);

export const selectLocationsItemsCount = createSelector([selectLocations], (locations) => locations.count);

export const selectLocationsItemsFilter = createSelector([selectLocations], (locations) => locations.filter);